// extracted by mini-css-extract-plugin
module.exports = {"defaultIconClass":"FAIcon_defaultIconClass__96d_b"};